import type { PropsWithChildren, ReactNode } from 'react'
import { forwardRef } from 'react'

import { Show } from '../../../components'
import { useActionContext } from '../context'
import css from './ActionRenderers.css'

type ActionProps = {
  actionTag: string
  settings?: ReactNode
}

export const Action = forwardRef<HTMLSpanElement, PropsWithChildren<ActionProps>>(function Action(
  { children, settings, actionTag },
  ref,
) {
  const { isSelectedAction, isEditingAction } = useActionContext()

  return (
    <span ref={ref} className={css.container}>
      <Show when={isSelectedAction(actionTag) || isEditingAction} fallback={children}>
        {settings}
      </Show>
    </span>
  )
})
